import cloneDeep from 'lodash/cloneDeep';
import flatMap from 'lodash/flatMap';
import isObjectLike from 'lodash/isObjectLike';
import moment from 'moment';
// import { searchTree, buildThreePath } from 'helpers';

const DEFAULT_DATE_VIEW_FORMAT = "DD.MM.YYYY HH:mm";


/**********************************************************
 *
 *           CONFIGURE FILTER CRITERIA OBJECT
 *
 **********************************************************/

/**
 * @param values {Object} values from redux-form
 * @param attributes {Array} all field configs
 */
export function configureFilterObject (values, attributes, dateSaveFormat) {
	let data = cloneDeep(attributes);
	if (data && values) {
		Object.keys(values).forEach(fieldName => {
			
			const filterCode = getCodeFromFieldName(fieldName);
			const filterIndex = data.findIndex(filter => filter.code === filterCode);
			
			if (filterIndex !== -1) {
				const filterData = data[filterIndex];
				
				if (['DATE', 'DATENAVMO'].includes(filterData.type) && filterData.def_condition === 'BTW') {
					setDateValue(filterData, fieldName, values[fieldName], dateSaveFormat);
				}
				else if (filterData.type === 'DATECAL' && filterData.def_condition === 'BTW') {
					setRangeDateValue(filterData, fieldName, values[fieldName], dateSaveFormat);
				}
				else {
					filterData.value = values[fieldName];
				}
			}
		});
		data = data.filter(filter => Boolean(filter.value));
		
		return flatMap(data, getRequestFilterObject)
			.filter(filter => Boolean(filter.value));
	}
	return [];
}

function setDateValue (filterData, fieldName, fieldValue, dateSaveFormat) {
	let parsedFieldValue = fieldValue;
	if (dateSaveFormat) {
		// check if fieldValue is in the same format as dateSaveFormat, if not - then try to parse it
		const isValid = moment(fieldValue, dateSaveFormat, true).isValid();
		if (!isValid) {
			const isDefaultFormat = moment(fieldValue, DEFAULT_DATE_VIEW_FORMAT, true).isValid();
			if (isDefaultFormat) {
				// convert value to correct dateSaveFormat
				const correctValue = moment(fieldValue, DEFAULT_DATE_VIEW_FORMAT).format(dateSaveFormat);
				parsedFieldValue = correctValue;
			} else {
				// if (fieldName.endsWith('@FROM')) {
				// 	parsedFieldValue = filterData.value ? filterData.value.from : null;
				// }
				// if (fieldName.endsWith('@TO')) {
				// 	parsedFieldValue = filterData.value ? filterData.value.to : null;
				// }

				// send null value as input is not correct
				parsedFieldValue = null;
			}
		}
	}
	// console.log({parsedFieldValue});
	// convert date to ISO format without timezone => "2024-05-02T00:00:00"
	if (parsedFieldValue) {
		// const date = new Date(parseInt(parsedFieldValue)).toISOString();
		const date = moment(+parsedFieldValue).utc(true).toISOString();
		parsedFieldValue = date;
	}
	if (fieldName.endsWith('@FROM')) {
		filterData.value = { ...filterData.value, from: parsedFieldValue };
	}
	if (fieldName.endsWith('@TO')) {
		filterData.value = { ...filterData.value, to: parsedFieldValue };
	}
}

function setRangeDateValue (filterData, fieldName, fieldValue, dateSaveFormat) {
	let startDate = fieldValue.startDate;
	if (startDate) {
		const convertedDate = moment(+parsedFieldValue).utc(true).toISOString();
		startDate = convertedDate;
	}
	let endDate = fieldValue.startDate;
	if (endDate) {
		const convertedDate = moment(+parsedFieldValue).utc(true).toISOString();
		endDate = convertedDate;
	}
	filterData.value = { ...filterData.value, from: startDate, to: endDate };
}

function getRequestFilterObject (filterData) {
	
	if (['LIST','LIST_CHECKBOX'].includes(filterData.type) && Array.isArray(filterData.value)) {
			return filterData.value.map(filterValue => ({
			id: filterData.id,
			condition: filterData.def_condition,
			value: getFilterValue(filterValue),
			label: filterValue.label,
		}));
	}
	
	if (filterData.type === 'THREE' && Array.isArray(filterData.value)) {
		return filterData.value.map(filterValue => ({
			id: filterData.id,
			condition: filterData.def_condition,
			value: getFilterValue(filterValue),
			label: filterValue.label,
		}));
	}
	
	if (['DATE','DATECAL','DATENAVMO'].includes(filterData.type) && filterData.def_condition === 'BTW') {
		return [{
			id: filterData.id,
			condition: 'GEQ',
			value: getFilterValue(filterData.value.from)
		}, {
			id: filterData.id,
			condition: 'LEQ',
			value: getFilterValue(filterData.value.to)
		}];
	}
	
	return {
		id: filterData.id,
		condition: filterData.def_condition,
		value: getFilterValue(filterData.value)
	};
}

function getFilterValue (filterFieldValue) {
	if (moment.isMoment(filterFieldValue)) {
		return filterFieldValue.isValid() ? filterFieldValue.format('YYYY-MM-DDTHH:mm:ss') : null;
	}
	
	if (isObjectLike(filterFieldValue)) return filterFieldValue.value;
	
	return filterFieldValue;
}

/**
 * @param {String} fieldName
 */
function getCodeFromFieldName (fieldName) {
	if (fieldName.endsWith('@FROM')) {
		return getStringWithoutEnding(fieldName, '@FROM');
	}
	if (fieldName.endsWith('@TO')) {
		return getStringWithoutEnding(fieldName, '@TO');
	}
	
	return fieldName;
}

/**
 * @param {String} string
 * @param {String} ending
 */
function getStringWithoutEnding (string, ending) {
	const endingIndex = string.lastIndexOf(ending);
	
	if (endingIndex === -1) return string;
	
	return string.substring(0, endingIndex);
}